// extracted by mini-css-extract-plugin
export var description = "search-module--description--EvyrQ";
export var details = "search-module--details--AzHo2";
export var hitActions = "search-module--hit-actions--trTmk";
export var hitContainer = "search-module--hit-container--S46Vi";
export var hitItem = "search-module--hit-item--qDWmK";
export var hitList = "search-module--hit-list--a8bZ5";
export var hitWrapper = "search-module--hit-wrapper--qj0+o";
export var pagination = "search-module--pagination--a+A5G";
export var searchBoxDescription = "search-module--search-box-description--B43O6";
export var searchContainer = "search-module--search-container--w8wy7";
export var searchFilters = "search-module--search-filters--H-NRI";
export var searchPanel = "search-module--search-panel--q3Gm1";
export var searchbox = "search-module--searchbox--mZm+2";
export var spacer = "search-module--spacer--xg+Dd";
export var titleHeader = "search-module--title-header--5Ofrr";